import { ERROR_PIPE_META_DATA } from "./errorsManager"

export const sentryAdapter = {
  // Let errors manager recognize the adapter
  adapterName: 'sentryAdapter',

  init() {
    // Add init functionality if needed
  },

  reportLocalStorageError(normalizedError) {
    if (!normalizedError) return

    this.reportError(normalizedError)
  },

  reportFetchError(normalizedError) {
    if (!normalizedError) return

    this.reportError(normalizedError)
  },

  reportError(normalizedError) {
    if (!normalizedError) return
    
    if (window && window.Sentry && window.Sentry.captureException) {

      try {
        window.Sentry.captureException(normalizedError)
      } catch (e) {
        console.error("Sentry error:", e)
      }
    }
  }
}
